<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <ul class="nav nav-pills nav-justified">
                            <li class="nav-item">
                                <a class="luna-nav-link" id="tab2" onclick="window.location.href = '/good/list'">
                                    <span class="badge rounded-pill bg-danger" style="
                          font-size: 10px;
                          position: absolute;
                          top: 25px;
                          margin-left: 110px;
                        " v-if="good_count > 0">{{ good_count }}</span>
                                    もらったいいね</a>
                            </li>
                            <li class="nav-item">
                                <a class="luna-nav-link luna-active" id="tab2">
                                    <span class="badge rounded-pill bg-danger" style="
                          font-size: 10px;
                          position: absolute;
                          top: 25px;
                          margin-left: 95px;
                        " v-if="matching_count > 0">{{ matching_count }}</span>マッチング中</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="wrap">
            <br />
            <div class="container" style="margin-top:50px;">
                <div class="row">
                    <div class="col text-center luna-color">
                        現在のマッチング中の人数：{{ count | priceLocaleString }}人
                    </div>
                </div>
                <div v-if="is_load">
                    <div class="row">
                        <div class="col text-center">
                            <div class="spinner-grow" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-if="count == 0">
                        <br />
                        <div class="container">
                            <div class="row">
                                <div class="col text-center">
                                    <i class="bi bi-hand-thumbs-up luna-color" style="font-size: 80px"></i>
                                </div>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col text-center">
                                    <h4>
                                        あなたと「マッチング」した<br />
                                        お相手が表示されます。
                                    </h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-center">
                                    <div style="color: #979c9e; font-size: 12px">
                                        プロフィールを充実させ、Twitterを連携&運用しましょう。<br />
                                        そうすることで、マッチング率が大幅に向上します<br />
                                    </div>
                                </div>
                            </div>
                            <br />
                            <br />
                            <div class="row">
                                <div class="col text-center">
                                    <button type="button" class="btn btn-luna" onclick="window.location.href = '/profile';">
                                        プロフィールを編集する
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="container">
                            <div class="row">
                                <div class="col text-center">
                                    <div style="color: #979c9e; font-size: 12px">
                                        タップして、Twitterから連絡をしてみましょう！
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col">
                                    <div class="text-center" v-if="is_advertisements" style="padding-bottom:10px;">
                                        <a :href="advertisements[ad_index].link_url" target="_blank">
                                            <img :src="advertisements[ad_index].ad_image" class="img-fluid" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div v-for="user in user_list" :key="user.id" class="row align-items-center"
                                style="padding: 10px 20px" @click="viewUser(user.id, user.matching_status, user.mid)">
                                <div class="col-3">
                                    <img :src="user.icon_url" class="rounded-circle" style="width: 100%" />
                                </div>
                                <div class="col text-truncate">
                                    <span style="color:#FF6D6D" v-if="user.is_view == 0">[New!]</span>{{ user.name }}
                                </div>
                                <div class="col-1 text-end">

                                    <span class="badge rounded-pill bg-danger" style="font-size: 10px;"
                                        v-if="user.is_msg_view == 0">N</span>
                                    <i class="bi bi-three-dots" v-else></i>
                                </div>
                            </div>
                            <div class="text-center" style="padding-top: 100px; padding-bottom: 20px; color: #6c7072"
                                v-if="is_page && count != 0">
                                <a @click="fetchUsersMore">もっとみる</a>
                            </div>
                            <div class="row" v-if="is_load_under">
                                <div class="col text-center">
                                    <div class="spinner-grow" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <br>
            <br>
            <br>
        </div>
        <FooterMenu currentPage="congratulation" />
    </div>
</template>

<script>
import FooterMenu from '../components/FooterMenu.vue';

export default {
    components: {
        FooterMenu
    },
    data() {
        return {
            is_advertisements: false,
            advertisements: [],
            ad_index: 0,
            age_list: [],
            area_list: [],
            count: 0,
            good_count: 0,
            is_load_under: false,
            is_load: true,
            is_page: true,
            matching_count: 0,
            page: 1,
            scrollY: 0,
            sex_list: [],
            user_list: [],
        };
    },
    mouted: function () {
        window.addEventListener("scroll", this.handleScroll)
    },
    methods: {
        async getAdvertisements() {
            axios.get("/api/advertisement/get/7")
                .then((response) => {
                    this.advertisements = response.data.advertisements

                    if (this.advertisements.length > 0) {
                        this.is_advertisements = true
                    }
                })
        },
        async fetchUsers() {
            await axios.get("/api/matching/congratulation/list")
                .then((response) => {
                    this.user_list = response.data.user_list.data
                    this.area_list = response.data.area_list
                    this.age_list = response.data.age_list
                    this.sex_list = response.data.sex_list
                    this.count = response.data.user_count
                    this.good_count = response.data.good_count
                    this.matching_count = response.data.matching_count

                    if (this.count <= 20) {
                        this.is_page = false
                    }

                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました", false)
                    }
                }).finally(() => {
                    this.is_load = false
                })
        },
        async fetchUsersMore() {
            this.is_load_under = true
            this.page++

            await axios.get("/api/matching/congratulation/list?page=" + this.page)
                .then((response) => {
                    this.user_list.push.apply(this.user_list, response.data.user_list.data)

                    if (response.data.user_list.data.length == 0) {
                        this.is_page = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.error("ユーザーの取得に失敗しました",{
                            icon:"error"
                        })
                    }
                }).finally(() => {
                    this.is_load_under = false
                })
        },
        async handleScroll() {
            let bottom = document.body.scrollHeight - document.body.clientHeight

            this.scrollY = window.scrollY
            let p = Math.abs(bottom - this.scrollY)
            if (p < 1 && this.is_page) {
                this.is_load_under = true
                this.page++
                await axios.get("/api/matching/congratulation/list?page=" + this.page)
                    .then((response) => {
                        this.user_list.push.apply(this.user_list, response.data.user_list.data)

                        if (response.data.user_list.data.length == 0) {
                            this.is_page = false
                        }
                    })
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("マッチング情報の取得に失敗しました")
                        }
                    }).finally(() => {
                        this.is_load_under = false
                    })
            }
        },
        async viewUser(u, s, m) {
            let response = await axios.get("/api/matching/view/set/" + u + "/" + s)
                .then((response) => {
                    window.location.href = "/user/message/" + m
                    //window.location.href = "/user/show/" + u
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("マッチング情報の取得に失敗しました", false)
                    }
                })
        }
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            localStorage.setItem('prev_page', this.$route.path)
                            localStorage.setItem('prev_type', 1)

                            window.addEventListener("scroll", this.handleScroll)
                            //this.getAdvertisements()
                            this.fetchUsers()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました", false)
                    })
            }
            else {
                localStorage.setItem('prev_page', this.$route.path)
                localStorage.setItem('prev_type', 1)

                window.addEventListener("scroll", this.handleScroll)
                //this.getAdvertisements()
                this.fetchUsers()
            }
        }
        else {
            localStorage.setItem('prev_page', this.$route.path)
            localStorage.setItem('prev_type', 1)

            window.addEventListener("scroll", this.handleScroll)
            //this.getAdvertisements()
            this.fetchUsers()
        }
    },
    filters: {
        omittedText(text) {
            if (text == null) {
                return ""
            } else {
                return text.length > 50 ? text.slice(0, 50) + "…" : text
            }
        },
        priceLocaleString(value) {
            return value.toLocaleString()
        },
    },
}
</script>
<style scoped>
#tab_detail_1 {
    animation: fadein 1.5s forwards;
}

.luna-header-box {
    position: fixed;
    height: 60px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
    padding: 20px 0;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
